import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subscription, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanySite } from '../../admin-dashboard/company-sites/company-sites.service';

export interface Site {
  key: string;
  name: string;
}



export interface FatTopBarLink {
  path: string;
  name: string;
}

export interface FatTopBarSetup {
  title: string;
  links: FatTopBarLink[];
  sites: CompanySite[];
}

@Component({
  selector: 'app-sub-top-bar',
  templateUrl: './sub-top-bar.component.html',
  styleUrls: ['./sub-top-bar.component.css']
})
export class SubTopBarComponent implements OnInit {

  @Input() setupObs: Observable<FatTopBarSetup>;

  activeLink = null;

  constructor(private router : Router,private route: ActivatedRoute) {

  }
  ngOnInit() {
  }

  checkActive(name,path) {
    if(!this.activeLink){
      console.log(this.activeLink)
      this.activeLink = name;
      this.router.navigateByUrl(path)
    }
     
    return this.activeLink == name
  }


}
